import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  header: {
    display: "flex",
    paddingTop: 10,
    paddingLeft: 24,
    paddingRight: 24,
    paddingBottom: 0,
    [theme.breakpoints.down("xs")]: {
      paddingLeft: 16,
      paddingRight: 16
    }
  },
  alertIcon: {
    marginRight: 4
  },
  horseName: {
    display: "flex",
    cursor: "pointer",
    marginRight: 4,
    fontSize: 16
  },
  schedulePreview: {
    flexGrow: 1,
    [theme.breakpoints.down("xs")]: {
      display: "none"
    }
  },
  scheduleLength: {
    fontSize: 16
  },
  horseNameAlert: {
    color: theme.palette.error.main,
    textDecoration: "underline",
    cursor: "pointer"
  },
  changesSavedWrapper: {
    flexGrow: 1,
    display: "flex",
    justifyContent: "flex-end",
    fontSize: 13,
    color: theme.palette.text.hint,
    lineHeight: "normal",
    marginRight: 32,
    whiteSpace: "nowrap",
    paddingLeft: 8
  },
  changesSavedIcon: {
    fontSize: 16
  },
  detailsLinkWrapper: {
    display: "flex",
    justifyContent: "flex-end",
    fontSize: 14,
    paddingLeft: 8,
    [theme.breakpoints.down("xs")]: {
      flexGrow: 1
    }
  },
  detailsLink: {
    display: "flex",
    cursor: "pointer",
    fontSize: 14,
    textDecoration: "none",
    color: theme.palette.text.primary
  },
  detailsLinkText: {
    fontSize: 14,
    whiteSpace: "nowrap",
    [theme.breakpoints.down("xs")]: {
      display: "none"
    }
  },
  detailsLinkIcon: {
    marginLeft: 10,
    fontSize: 20
  },
  horseNameLinkView: {
    color: theme.palette.warning.dark,
    textDecoration: "underline",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "none"
    }
  },
  horseshoeButton: {
    minWidth: 30,
    height: 25,
    padding: 0
  },
  horseShoe: {
    fill: theme.palette.warning.dark,
    width: 17
  }
}));
